import { useLocation, Link as RouterLink } from 'react-router-dom';

import { Box, Link, styled, Typography, Breadcrumbs } from '@mui/material';

export const BreadcrumbsSeparator = styled('span')(({ theme }) => ({
  width: 4,
  height: 4,
  borderRadius: '50%',
  backgroundColor: theme?.vars?.palette?.text?.disabled,
}));

interface DynamicBreadcrumbsProps {
  crumbStartPath: string;
}

// ----------------------------------------------------------------------
// TODO: this component needs to be revisited in order to handle params attribute params.

export default function DynamicBreadcrumbs({ crumbStartPath }: DynamicBreadcrumbsProps) {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const employerDataIndex = pathnames.indexOf(crumbStartPath);
  const filteredPathnames = employerDataIndex !== -1 ? pathnames.slice(employerDataIndex) : [];

  const pathNamesNoParams = filteredPathnames.filter((pathname) => Number.isNaN(Number(pathname)));
  const lastBreadcrumb = pathNamesNoParams[pathNamesNoParams.length - 1];

  return (
    <Box sx={{ mb: { xs: 3, md: 5 }, mt: 1 }}>
      <Breadcrumbs
        separator={<BreadcrumbsSeparator />}
        aria-label="breadcrumb"
        data-testid="dynamic-breadcrumbs"
      >
        {filteredPathnames.map((value, index) => {
          // Skip rendering if the value is a parameter (numeric)
          if (!Number.isNaN(Number(value))) {
            // index++;
            return null;
          }
          const to = `/${pathnames.slice(0, employerDataIndex + index + 2).join('/')}`;

          const isLast = value === lastBreadcrumb;

          value = value.replaceAll('-', ' '); // Replace hyphens with spaces
          value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(); // Capitalize first letter and lowercase the rest

          return isLast ? (
            <Typography key={to} color="text.primary">
              {value}
            </Typography>
          ) : (
            <Link key={to} component={RouterLink} to={to} color="inherit">
              {value}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
}
